import getAuthN from './utils/getAuthN';

export default async (): Promise<boolean> => {
  if (window?.CONFIG?.ENV === 'local') {
    return Promise.resolve(false);
  }

  const authN = getAuthN();
  const user = await authN.getUser();

  return user?.['http://seek/claims/customer_service_view'] === true;
};
